import React, { ReactNode } from 'react';
import { ComponentBaseProps } from 'types';
import { capitalizeFirstLetter } from 'utils';

export type MenuHeaderProps = {
  name: string;
  avatar: ReactNode;
  rightIcon?: ReactNode;
  iconClassName?: string;
  isProfile?: boolean;
  rightIconBorder?: boolean;

  onItemClick?: (event: { target: any }) => void;
  onClickRightIcon?: (event: { target: any }) => void;
} & ComponentBaseProps;

export const MenuHeader = ({
  name,
  avatar,
  rightIcon,
  style = {},
  className = '',
  iconClassName = '',
  onClickRightIcon,
  isProfile,
  onItemClick,
  rightIconBorder,
}: MenuHeaderProps) => {
  return (
    <div
      style={{ marginBottom: -1, paddingLeft: -8, ...style }}
      onClick={onItemClick}
      className={`flex py-1 items-center w-full justify-between ${className}`}
    >
      <div className='flex ml-3 items-center rounded'>
        <div className='w-10' onClick={event => event.stopPropagation()}>
          {avatar}
        </div>
        <h2 className='ml-2 text-black w-48 overflow-hidden whitespace-nowrap text-ellipsis'>
          {name}
        </h2>
      </div>
      <div
        data-testid={`HomePage-${isProfile ? 'profile' : 'initiative'}-toggle`}
        className={`flex flex-col w-8 h-6 mr-2 justify-center items-center cursor-pointer ${
          rightIconBorder ? 'border border-gray-300 rounded hover:bg-white' : ''
        } ${iconClassName}`}
        onClick={onClickRightIcon}
      >
        {rightIcon}
      </div>
    </div>
  );
};
